import { render, staticRenderFns } from "./InteresMoratorio.vue?vue&type=template&id=b6fd937a&"
import script from "./InteresMoratorio.vue?vue&type=script&lang=js&"
export * from "./InteresMoratorio.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports